<template>
  <div class="empty-wrap">
    <img src="./empty-image-default.png">
    <p>{{ tip }}</p>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    tip: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="stylus" scoped>
.empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;

  img {
    width: 160px;
  }

  p {
    margin-top: 50px;
    padding: 0 60px;
    color: #969799;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
